import { Custom } from '@clearkit/icons';
import { CKLayoutHorizontal } from 'clearkit';

// import { useState } from 'react';
// import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';
import { HomeHeading } from '../HomeHeading';
import { ImplementationCardCarousel } from '../ImplementationSteps/ImplementationCardCarousel';

// const filterItems = [
//   {
//     label: 'Displaying all steps',
//     value: 'all',
//   },
//   {
//     label: 'Displaying remaining steps',
//     value: 'remaining',
//   },
// ];

export const HomeSectionImplementation = () => {
  /**
   * @todo Restore when we have more steps
   * @todo Align logic CRM connection step to ConnectCRM.tsx
   * Currently, hasConnectors is false when the CRM is disconnected
   * but we want that a CRM was ever connected here
   */
  // const [filter, setFilter] = useState(filterItems[0]);
  // const showAll = filter.value === 'all';

  // const { hasConnectors, hasTagsTraffic } = useOnboardingStatus();
  // Filter out false values
  // const remainingSteps = [hasConnectors, hasTagsTraffic].filter(
  //   (step) => !step,
  // );
  // const maxSteps = 2;
  // const remainingStepsCount = maxSteps - remainingSteps.length;
  // const progress = Math.round((remainingStepsCount / maxSteps) * 100);

  return (
    <section className="space-y-6">
      <CKLayoutHorizontal as="header">
        <CKLayoutHorizontal gap="1.5rem">
          <HomeHeading>
            <Custom /> Clearbit Onboarding
          </HomeHeading>
          {/**
           * @todo Restore when we have more steps
           */}
          {/* <CKSelectButton
            className="relative top-0.5"
            items={filterItems}
            onChange={setFilter}
            triggerVariantColor="blue"
            value={filter}
          >
            <CKSelectButton.IconLeft>
              <Filter />
            </CKSelectButton.IconLeft>
          </CKSelectButton> */}
        </CKLayoutHorizontal>
        {/* <CKLayoutHorizontal gap="0.5rem" justifyContent="start">
          <CKProgressBar
            className="w-20"
            max={maxSteps}
            value={remainingStepsCount}
            variant="x"
          />
          <CKProgressBar.LabelRight className="text-sm">
            {progress}% complete
          </CKProgressBar.LabelRight>
        </CKLayoutHorizontal> */}
      </CKLayoutHorizontal>
      <ImplementationCardCarousel showAll />
    </section>
  );
};
